import { useState } from "react";

export function ForgotPassword({ isOpen, onClose, onSave }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false); // Loading state

  if (!isOpen) return null;

  const handleSave = async () => {
    setLoading(true); // Start loading
    await onSave(email); // Wait for onSave to complete
    setLoading(false); // Stop loading
    onClose(); // Close modal after saving
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-60 backdrop-blur-sm">
      {/* Modal container */}
      <div className="bg-white p-6 rounded-lg shadow-2xl max-w-sm w-full mx-4">
        <h2 className="text-xl font-semibold mb-4 text-center">Enter Your Email</h2>

        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="w-full p-3 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-zinc-400"
          disabled={loading} // Disable input when loading
        />

        <div className="flex justify-center space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-zinc-100 text-black rounded hover:bg-zinc-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
            disabled={loading} // Disable button when loading
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className={`px-4 py-2 text-white rounded focus:outline-none focus:ring-2 ${
              loading ? "bg-gray-400 cursor-not-allowed" : "bg-black hover:bg-zinc-800"
            }`}
            disabled={loading} // Disable button when loading
          >
            {loading ? "Sending..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};